/**
 * Pincode checker (India Post API). If fetch fails in the browser console,
 * the host may block CORS; use an app proxy or server-side route if needed.
 */
(function () {
  function getDeliveryDate(addDays) {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + addDays);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const dayIndex = deliveryDate.getDay();

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthIndex = deliveryDate.getMonth();

    return `Get delivery before ${days[dayIndex]}, ${deliveryDate.getDate()} ${months[monthIndex]} if ordered today.`;
  }

  function parseDeliveryDays(root) {
    const raw = root.getAttribute('data-delivery-days');
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : 8;
  }

  function getLocationFromInfo(info) {
    if (!info || !info.PostOffice || !info.PostOffice.length) return '';
    const po = info.PostOffice[0];
    const name = (po.Name || '').trim();
    const district = (po.District || '').trim();
    const state = (po.State || '').trim();
    const parts = [name, district, state].filter(Boolean);
    return parts.join(', ');
  }

  function initRoot(root) {
    const input = root.querySelector('.pin-code-checker__input');
    const btn = root.querySelector('.pin-code-check-btn');
    const successMsgDiv = root.querySelector('.pin-code-success-msg');
    const successLocation = root.querySelector('.pin-code-success-location');
    const successMsgText = root.querySelector('.pin-code-success-text');
    const errorMsg = root.querySelector('.pin-code-err-msg');
    const deliveryDays = parseDeliveryDays(root);

    if (!input || !btn || !successMsgDiv || !successLocation || !successMsgText || !errorMsg) return;

    function setSuccessVisible(show) {
      if (show) {
        successMsgDiv.style.display = 'flex';
        successMsgDiv.classList.add('pin-code-msg--visible');
      } else {
        successMsgDiv.style.display = 'none';
        successMsgDiv.classList.remove('pin-code-msg--visible');
      }
    }

    function setErrorVisible(show) {
      if (show) {
        errorMsg.style.display = 'flex';
        errorMsg.classList.add('pin-code-msg--visible');
      } else {
        errorMsg.style.display = 'none';
        errorMsg.classList.remove('pin-code-msg--visible');
      }
    }

    input.addEventListener('input', function () {
      let v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v;
    });

    function getPinDigits() {
      return input.value.trim().replace(/\D/g, '');
    }

    function validatePin() {
      const pin = getPinDigits();
      return pin.length >= 6 && pin.length <= 8;
    }

    async function fetchPinCodes() {
      if (!validatePin()) {
        setSuccessVisible(false);
        successLocation.textContent = '';
        successMsgText.textContent = '';
        setErrorVisible(true);
        return;
      }

      // India Post API expects a 6-digit pin; we send the first 6 digits when 6–8 are entered.
      const pinCode = Number(getPinDigits().slice(0, 6));

      try {
        const response = await fetch('https://api.postalpincode.in/pincode/' + pinCode);
        const data = await response.json();
        const info = data && data[0];

        if (info && info.Status === 'Success') {
          setErrorVisible(false);
          const locationLine = getLocationFromInfo(info);
          successLocation.textContent = locationLine;
          successLocation.style.display = locationLine ? 'block' : 'none';
          successMsgText.textContent = getDeliveryDate(deliveryDays);
          successMsgText.style.display = 'block';
          setSuccessVisible(true);
        } else {
          setSuccessVisible(false);
          successLocation.textContent = '';
          successMsgText.textContent = '';
          setErrorVisible(true);
        }
      } catch (err) {
        setSuccessVisible(false);
        successLocation.textContent = '';
        successMsgText.textContent = '';
        setErrorVisible(true);
      }
    }

    btn.addEventListener('click', fetchPinCodes);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        fetchPinCodes();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pin-code-checker]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
